import { useEffect } from "react";
import useIsTouchDevice from "./useTouchDevice";

const useDeviceActiveState = (onDeviceActive) => {
  const isTouchDevice = useIsTouchDevice();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (isTouchDevice) {
        if (!document.hidden) {
          onDeviceActive();
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [onDeviceActive]);
};

export default useDeviceActiveState;
